<template>
  <div class="animated fadeIn">
    <b-row class="mb-0 mt-0 pt-1">
      <!-- <b-col md="3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth_Less">Date</b-input-group-text>
                  </b-input-group-prepend>
                  <datepicker
                    @dp-change="addDirtyField"
                    :value="seminar.seminar_edit.DateContractReceived"
                    :config="options"
                    id="ContractReceivedDate"
                  />
                </b-input-group>
              </b-form-group>
      </b-col>-->
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth">Seminar Date</b-input-group-text>
            </b-input-group-prepend>
            <datepicker v-model="current_seating.DateOfSeating" :config="options" id="SeatingDate" />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <CoolSelect
            v-model="current_seating.SeminarTypeID"
            placeholder="Type"
            theme="bootstrap"
            tooltip="Seminar Type"
            :items="seminar.seminar_types"
            item-text="SeminarTypeName"
            item-value="SeminarTypeID"
            id="SeminarTypeID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth">Seminar Type</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group>
          <CoolSelect
            v-model="current_seating.CuisineID"
            placeholder="Cuisine"
            theme="bootstrap"
            tooltip="Cuisine"
            :items="seminar.cuisines"
            item-text="CuisineType"
            item-value="CuisineID"
            id="CuisineID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth">Cuisine</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-0 mt-0">
      <b-col sm="12">
        <b-form-group>
          <CoolSelect
            v-model="current_seating.RestaurantID"
            placeholder="Select Restaurant"
            theme="bootstrap"
            tooltip="Restaurant"
            :items="seminar.restaurants"
            item-text="Name"
            item-value="RestaurantID"
            id="RestaurantID"
            @select="setRestaurantName"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth">Restaurant</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth_Small">RSVP</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_seating.Attendee1Count"
              placeholder
              type="text"
              autocomplete="off"
              id="Attendee1Count"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth_Small">Wait</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_seating.WaitList1Count"
              placeholder
              type="text"
              autocomplete="off"
              id="WaitList1Count"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col v-if="current_seminar.IsSplit" md="2">
        <b-form-group v-if="current_seminar.IsSplit">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth_Small">RSVP-2</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_seating.Attendee2Count"
              placeholder
              type="text"
              autocomplete="off"
              id="Attendee2Count"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col v-if="current_seminar.IsSplit" md="2">
        <b-form-group v-if="current_seminar.IsSplit">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth_Small">Wait-2</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_seating.WaitList2Count"
              placeholder
              type="text"
              autocomplete="off"
              id="WaitList2Count"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth_Small">Web</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_seating.Web1Count"
              placeholder
              type="text"
              autocomplete="off"
              id="Web1Count"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth_Small">Other</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_seating.OtherRSVPCount"
              placeholder
              type="text"
              autocomplete="off"
              id="OtherRSVPCount"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <i
          v-if="this.current_seminar.Seatings.length>1"
          v-b-tooltip
          title="Delete Seminar Date"
          class="fa fa-trash fa-lg mt-2 pt-1 clickIcon"
          @click="deleteSeating"
        ></i>
      </b-col>
    </b-row>

    <hr />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import { CoolSelect } from "vue-cool-select";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "SeatingRow",
  components: {
    StyledDialog,
    CoolSelect,
    datepicker,
  },
  props: {
    seating_object: { type: Object },
    seminar_object: { type: Object },
  },
  data() {
    return {
      current_seating: this.seating_object,
      current_seminar: this.seminar_object,
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
      options: {
        format: "MM/DD/YYYY",
        useCurrent: true,
        // ,
        // minDate: new Date()
        // ,
        // daysOfWeekDisabled: [0, 6]
      },
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    deleteSeating() {
      this.$emit("RemoveSeating", this.current_seating);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      // this.$v.$touch();
      // if (this.$v.$error) {
      //   this.dismiss2CountDown = this.dismiss2Secs;
      // } else {
      //   this.$store
      //     .dispatch("dealership/Save", {
      //       client: this.$store.state.seminar.restaurant_edit,
      //       fields: this.dirtyFields
      //     })
      //     .then(
      //       (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
      //     );
      // }
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },
    saveField: function (event) {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        SeatingID: this.current_seating.SeatingID,
        FieldToSet: event.target.id,
        ValueToSet: event.target.value,
      };

      this.$store
        .dispatch("seminar/SaveSeating", _operation)
        .then();
    },
    addDirtyField: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function (field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSwitch: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString(),
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    setRestaurantName(event) {
      var _t = this.$store.state.seminar.restaurants.find(rest => rest.RestaurantID === event.RestaurantID);
      this.current_seating.Restaurant = _t;
    },
    async setSeatingID()
    {
      var _api  = await this.$store
        .dispatch("seminar/AddSeating", this.current_seating)
         this.current_seating.SeatingID = _api.data["AddSeatingResult"];
    }
  },
  computed: {
    ...mapState(["seminar", "territory", "n_user"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
  },
  created() {},
  watch: {
    "current_seating.RestaurantID": function () {
      var _event = {
        target: {
          id: "RestaurantID",
          value: this.current_seating.RestaurantID,
        },
      };
      this.saveField(_event);
    },
    "current_seating.CuisineID": function () {
      var _event = {
        target: { id: "CuisineID", value: this.current_seating.CuisineID },
      };
      this.saveField(_event);
    },
    "current_seating.DateOfSeating": function () {
      this.$emit("ChangeSeatingDate");
      var _event = {
        target: {
          id: "SeatingDate",
          value: this.current_seating.DateOfSeating,
        },
      };
      this.saveField(_event);
    },
    "current_seating.SeminarTypeID": function () {
      var _event = {
        target: {
          id: "SeminarTypeID",
          value: this.current_seating.SeminarTypeID,
        },
      };
      this.saveField(_event);
    },
  },
  mounted() { },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
